import { authAxios } from "@/api";
import { API_VER, ROOT_URL } from "@/setup/constants";

const API_CONTROLLER = "ward";

export class AppointmentApi {
  static getAppointmentDetail(wardId, appointmentId) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointment/${appointmentId}`;
    return authAxios.get(url);
  }

  static updateAppointmentDetail(wardId, appointmentId, appointmentInfo){
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointment/${appointmentId}`;
    return authAxios.put(url, appointmentInfo);
  }

  static createAppointment(wardId, appointmentInfo) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointment`;
    return authAxios.post(url, appointmentInfo);
  }

  static deleteAppointment(wardId, appointmentId) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointment/${appointmentId}`;
    return authAxios.delete(url);
  }

  static searchAppointments(wardId, filterInfo) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointments`;
    return authAxios.post(url, filterInfo);
  }

  static searchAppointmentEvents(wardId, appointmentId, filterInfo) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointment/${appointmentId}/events`;
    return authAxios.post(url, filterInfo);
  }
}
